














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TimeField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop(String) public readonly labelCols!: string;
  @Prop(String) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;

  public hours = '';
  public minutes = '';

  public saveTime(isMinutes: boolean) {
    // Check if input is valid
    const validHours = this.checkValidHours();
    const validMinutes = this.checkValidMinutes();
    // console.log('TimeField.saveTime', this.hours, this.minutes, validHours, validMinutes);
    // Format valid inputs and remove invalid inputs
    if (validHours && this.minutes === '') {
      // this.minutes = '00';
    }
    if (!validHours) {
      // Reset time and empty minutes field
      this.minutes = '';
      this.rec[this.field] = null;
    } else if (!validMinutes) {
      // Reset time and set default minutes field
      if (isMinutes) {
        this.minutes = '00';
      }
      this.rec[this.field] = this.hours + ':00:00';
    } else {
      // Save time
      this.rec[this.field] = this.hours + ':' + this.minutes + ':00';
    }
  }

  // Return true if the input is a valid number of hours
  public checkValidHours() {
    // console.log('TimeField.checkValidHours', this.hours, this.hours.length);
    if (this.hours.length === 1 || this.hours.length === 2) {
      if (this.parseNumber(this.hours) < 24) {
        this.hours = this.formatNumber(this.hours);
        return true;
      } else {
        this.hours = '';
        return false;
      }
    } else {
      this.hours = '';
      return false;
    }
  }

  // Return true if the input is a valid number of minutes
  public checkValidMinutes() {
    // console.log('TimeField.checkValidMinutes', this.minutes, this.minutes.length);
    if (this.minutes.length === 1 || this.minutes.length === 2) {
      const n = this.parseNumber(this.minutes);
      if (n < 60) {
        if (n % 15 !== 0) {
          this.minutes = (Math.round(n / 15.0) * 15).toString();
        }
        this.minutes = this.formatNumber(this.minutes);
        return true;
      } else {
        this.minutes = '';
        return false;
      }
    } else {
      this.minutes = '';
      return false;
    }
  }

  // Add leading zero if the number has only one digit
  public formatNumber(n) {
    return n.length === 1 ? '0' + n : n;
  }

  // Parse string to valid number, remove leading zeros
  public parseNumber(n) {
    return Number(n.replace(/^0+/, ''));
  }

  public nextElement(e) {
    // console.log('TimeField.nextElement');
    const elem = e.target;
    const currentIndex = Array.from(elem.form.elements).indexOf(elem);
    let nextElem = elem.form.elements.item(
      currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
    );
    if (nextElem.tabIndex === -1) {
      // Skip element - clear icon
      nextElem = elem.form.elements.item(
        currentIndex < elem.form.elements.length - 2 ? currentIndex + 2 : 0
      );
    }
    nextElem.select();
    this.$emit('enter', e);
  }

  public created() {
    this.$watch(
      function() { return this.rec[this.field]; },
      function(newValue, oldValue) {
          // console.log('TimeField.$watch', oldValue, '->',  newValue);
          if (newValue && oldValue !== newValue) {
            this.hours = newValue.split(':')[0];
            this.minutes = newValue.split(':')[1];
          }
        }
    );
  }
}
